import { useQuery } from "react-query";
import { getServiceProvided } from "../../../../actions/CarrierAgreementMgmt/OfficeVendorService";

export const useServiceProvided = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetServiceProvided",
    getServiceProvided,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
